module.exports = __webpack_public_path__ + "static/media/Create_Folder.ff056071.gif";